var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React from 'react';
import styled from '@emotion/styled';
import { theme } from 'src/Utils';
var mentionRegex = /(@[A-Za-z0-9ÁÉÍÓÚáéíóúÑñ._-]+(?:\s+[A-Za-z0-9ÁÉÍÓÚáéíóúÑñ._-]+)?)/g;
var MENTION_BOUNDARY_REGEX = /[\s.,;:!?()[\]{}"']/;
var tokenizeByValidMentions = function (text, validMentions) {
    var mentionsByLength = __spreadArrays(validMentions).sort(function (first, second) { return second.length - first.length; });
    var segments = [];
    var buffer = '';
    var cursor = 0;
    var flushBuffer = function () {
        if (!buffer)
            return;
        segments.push({ text: buffer, isMention: false });
        buffer = '';
    };
    while (cursor < text.length) {
        if (text[cursor] !== '@') {
            buffer += text[cursor];
            cursor += 1;
            continue;
        }
        var mentionMatch = mentionsByLength.find(function (mention) {
            var candidate = text.slice(cursor + 1, cursor + 1 + mention.length);
            if (candidate.toLowerCase() !== mention.toLowerCase())
                return false;
            var nextChar = text[cursor + 1 + mention.length];
            return !nextChar || MENTION_BOUNDARY_REGEX.test(nextChar);
        });
        if (!mentionMatch) {
            buffer += text[cursor];
            cursor += 1;
            continue;
        }
        flushBuffer();
        segments.push({
            text: text.slice(cursor, cursor + mentionMatch.length + 1),
            isMention: true,
        });
        cursor += mentionMatch.length + 1;
    }
    flushBuffer();
    return segments;
};
var Mention = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-weight: 600;\n  border-radius: 6px;\n  padding: 1px 2px;\n  transition: background-color 0.18s ease, color 0.18s ease;\n  cursor: default;\n\n  &:hover {\n    background: ", ";\n    color: ", ";\n  }\n"], ["\n  color: ", ";\n  font-weight: 600;\n  border-radius: 6px;\n  padding: 1px 2px;\n  transition: background-color 0.18s ease, color 0.18s ease;\n  cursor: default;\n\n  &:hover {\n    background: ", ";\n    color: ", ";\n  }\n"])), theme.palette.admin.primary[75], theme.palette.blueShadow[10], theme.palette.admin.primary[60]);
export var MentionText = function (_a) {
    var text = _a.text, validMentions = _a.validMentions;
    var normalizedValidMentions = (validMentions || []).map(function (mention) { return mention.toLowerCase(); });
    var hasValidMentions = normalizedValidMentions.length > 0;
    var validMentionSet = new Set(normalizedValidMentions);
    var segments = hasValidMentions
        ? tokenizeByValidMentions(text, validMentions || [])
        : text.split(mentionRegex).map(function (segment) { return ({
            text: segment,
            isMention: segment.startsWith('@'),
        }); });
    return (React.createElement(React.Fragment, null, segments.map(function (segment, index) {
        var mentionLabel = segment.text.startsWith('@')
            ? segment.text.slice(1).toLowerCase()
            : '';
        var isValidMention = segment.isMention &&
            (validMentionSet.size === 0 || validMentionSet.has(mentionLabel));
        if (isValidMention) {
            return (React.createElement(Mention, { key: segment.text + "-" + index, title: "Menci\u00F3n" }, segment.text));
        }
        return React.createElement(React.Fragment, { key: segment.text + "-" + index }, segment.text);
    })));
};
var templateObject_1;
